module.exports = __webpack_public_path__ + "static/media/RnR-setup-complete-bg.0ead9e06.svg";